import { View } from "./view";
import { ServiceLocator } from "./service-locator";
import { CornerType } from "./model/corner-type";
import { KonvaBox } from "./box-service";

export class Controller {
  public static toggleColor(current_box: KonvaBox | undefined): void {
    const boxService = ServiceLocator.boxService;

    boxService.toggleColor();

    this.updateCubesMenu();

    const selectedStillExists =
      current_box !== undefined &&
      boxService.getKonvoBoxes().includes(current_box);

    this.updateCubeMenu(selectedStillExists ? current_box : undefined);

    View.updateButtons(boxService.getColor());
  }

  public static updateCubeMenu(current_box: KonvaBox | undefined) {
    if (current_box !== undefined) {
      const boxService = ServiceLocator.boxService;

      View.showHideCubeMenuUsageNote(false);

      View.showHideCubeMenuItem(true, "delete");

      if (boxService.isCorner(current_box)) {
        View.showHideCubeMenuItem(false, "back");
        View.showHideCubeMenuItem(false, "door");
        View.showHideCubeMenuItem(false, "shelves");
        View.showHideCubeMenuItem(false, "top-drawer");
        View.showHideCubeMenuItem(false, "middle-drawer");
        View.showHideCubeMenuItem(false, "bottom-drawer");
        View.showHideCubeMenuItem(false, "cross-divider");

        View.showHideCubeMenuItem(true, "corner");

        View.showHideCubeMenuNote(false);
      } else {
        View.showHideCubeMenuItem(true, "back");
        View.showHideCubeMenuItem(true, "door");
        View.showHideCubeMenuItem(true, "shelves");
        View.showHideCubeMenuItem(true, "top-drawer");
        View.showHideCubeMenuItem(true, "middle-drawer");
        View.showHideCubeMenuItem(true, "bottom-drawer");
        View.showHideCubeMenuItem(true, "cross-divider");

        View.showHideCubeMenuItem(false, "corner");

        View.updateCubeSelectionInMenu(boxService.hasBack(current_box), "back");
        View.updateCubeSelectionInMenu(
          boxService.hasDoors(current_box),
          "door",
        );
        View.updateCubeSelectionInMenu(
          boxService.hasShelves(current_box),
          "shelves",
          "Shelves (" + boxService.getShelvesCount(current_box) + ")",
        );
        View.updateCubeSelectionInMenu(
          boxService.hasTopDrawer(current_box),
          "top-drawer",
        );
        View.updateCubeSelectionInMenu(
          boxService.hasMiddleDrawer(current_box),
          "middle-drawer",
        );
        View.updateCubeSelectionInMenu(
          boxService.hasBottomDrawer(current_box),
          "bottom-drawer",
        );
        View.updateCubeSelectionInMenu(
          boxService.hasCrossDivider(current_box),
          "cross-divider",
        );

        View.enableDisableCubeOptionInMenu(
          boxService.supportsBack(current_box),
          "back",
        );
        View.enableDisableCubeOptionInMenu(
          boxService.supportsCrossDivider(current_box),
          "cross-divider",
        );
        View.enableDisableCubeOptionInMenu(
          boxService.supportsDoor(current_box),
          "door",
        );

        View.showHideCubeMenuNote(true);
      }
    } else {
      View.showHideCubeMenuUsageNote(true);

      View.showHideCubeMenuItem(false, "delete");

      View.showHideCubeMenuItem(false, "back");
      View.showHideCubeMenuItem(false, "door");
      View.showHideCubeMenuItem(false, "shelves");
      View.showHideCubeMenuItem(false, "top-drawer");
      View.showHideCubeMenuItem(false, "middle-drawer");
      View.showHideCubeMenuItem(false, "bottom-drawer");

      View.showHideCubeMenuItem(false, "corner");
      View.showHideCubeMenuItem(false, "cross-divider");

      View.showHideCubeMenuNote(false);
    }
  }

  public static updateCubesMenu(): void {
    const boxService = ServiceLocator.boxService;

    if (boxService.isTallBoxAvailable()) {
      View.enableTallBox();
    } else {
      View.disableTallBox();
    }

    if (boxService.isCornerAvailable(CornerType.tallCorner)) {
      View.enableCorner(CornerType.tallCorner);
    } else {
      View.disableCorner(CornerType.tallCorner);
    }

    if (boxService.isCornerAvailable(CornerType.smallCorner)) {
      View.enableCorner(CornerType.smallCorner);
    } else {
      View.disableCorner(CornerType.smallCorner);
    }
  }
}
